"use client";
import { Button } from "../../components/ui/button";
import { Heart, Users, MessageCircle, ArrowRight } from "lucide-react";
import { motion } from "motion/react";
import { useAppDispatch, useAppSelector } from "../../_hooks/hooks";
import { useEffect, useState } from "react";
import { ICMS } from "../home/homeModel";
import { createLookupObject } from "../../_helper/helper";
import Link from "next/link";
import { getAllActiveWeddingVenues } from "./services/wedding.services";
import { setWeddingVenueList } from "./weddingSlice";
import { OptimizedImage } from "../../components/common/OptimizedImage";
import { Preloader } from "../../components/Preloader";

export default function DestinationWeddingNew({
  initialCMS,
  initialVenues,
}: {
  initialCMS?: any[];
  initialVenues?: any[];
}) {
  // const dispatch = useAppDispatch();
  const homeLoading = useAppSelector((state) => state.home.loading);
  const BannerList = useAppSelector((state) => state.home.BannerList);
  const SettingList = useAppSelector((state) => state.home.SettingList);

  const CMSList = initialCMS;
  const WeddingVenueList = initialVenues || [];

  const [lookUpCMSData, setLookUpCMSData] = useState<Record<string, ICMS>>({});

  const WhatsAppNo = SettingList?.find(
    (setting: any) => setting?.SettingKey === "WhatsAppNo",
  )?.SettingValue;
  const phone = WhatsAppNo ? WhatsAppNo.replace(/\D+/g, "") : "";
  const whatsappLink = `https://wa.me/${phone}?text=${encodeURIComponent("Hello, I’d like to know more details.")}`;

  useEffect(() => {
    if (CMSList && CMSList?.length > 0) {
      setLookUpCMSData(createLookupObject(CMSList, "Name"));
    }
  }, [CMSList]);

  // useEffect(() => {
  //   // Hydrate Venues
  //   if (
  //     initialVenues &&
  //     (!storeWeddingVenueList || storeWeddingVenueList.length === 0)
  //   ) {
  //     dispatch(setWeddingVenueList(initialVenues));
  //   } else if (!storeWeddingVenueList || storeWeddingVenueList.length === 0) {
  //     dispatch(getAllActiveWeddingVenues());
  //   }
  // }, [dispatch, initialVenues]);

  const banner: any =
    BannerList?.find((banner) => banner?.BannerType === "weddings-events") ||
    [];

  // const venues = [
  //   {
  //     name: "Kavish Jawai - Wilderness Wedding",
  //     image:
  //       "https://images.unsplash.com/photo-1646358047813-055e7f42c7ea?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxsZW9wYXJkJTIwd2lsZGxpZmUlMjBzYWZhcml8ZW58MXx8fHwxNzY4OTY5NzYwfDA&ixlib=rb-4.1.0&q=80&w=1080",
  //     description:
  //       "Exchange vows amidst dramatic granite hills with nature as your witness",
  //     capacity: "50-100 guests",
  //     highlight: "Unique wilderness backdrop",
  //   },
  //   {
  //     name: "Kavish Udaipur - Royal Romance",
  //     image:
  //       "https://images.unsplash.com/photo-1622018135960-249abd263aeb?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx1ZGFpcHVyJTIwbGFrZSUyMHBhbGFjZXxlbnwxfHx8fDE3Njg5Njk3NjB8MA&ixlib=rb-4.1.0&q=80&w=1080",
  //     description: "Lakeside ceremonies with palace views and regal grandeur",
  //     capacity: "100-200 guests",
  //     highlight: "Palace & lake views",
  //   },
  //   {
  //     name: "Kavish Kumbhalgarh - Fort Heritage",
  //     image:
  //       "https://images.unsplash.com/photo-1762498509471-58f3482089d1?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxrdW1iaGFsZ2FyaCUyMGZvcnQlMjBoaWxsc3xlbnwxfHx8fDE3Njg5Njk3NjF8MA&ixlib=rb-4.1.0&q=80&w=1080",
  //     description: "Mountain-top celebrations with ancient fort backdrops",
  //     capacity: "75-150 guests",
  //     highlight: "UNESCO World Heritage backdrop",
  //   },
  // ];

  // const services = [
  //   {
  //     icon: Users,
  //     title: "Dedicated Wedding Planner",
  //     description:
  //       "Your personal planner handles every detail from start to finish",
  //   },
  //   {
  //     icon: Utensils,
  //     title: "Customized Menus",
  //     description: "Multi-cuisine options tailored to your preferences",
  //   },
  //   {
  //     icon: Music,
  //     title: "Entertainment & Décor",
  //     description: "Complete event styling and live performances",
  //   },
  //   {
  //     icon: Camera,
  //     title: "Photography & Videography",
  //     description: "Professional teams to capture every precious moment",
  //   },
  //   {
  //     icon: Sparkles,
  //     title: "Bridal Services",
  //     description: "Makeup, styling, and spa treatments",
  //   },
  //   {
  //     icon: MapPin,
  //     title: "Guest Management",
  //     description: "Accommodation and transport coordination",
  //   },
  // ];

  // const packages = [
  //   {
  //     name: "Intimate Celebration",
  //     guests: "Up to 50 guests",
  //     price: "Starting ₹8 Lakhs",
  //     features: [
  //       "2-day celebration",
  //       "Basic décor & lighting",
  //       "DJ or live music",
  //       "3-meal catering",
  //       "Basic photography",
  //     ],
  //   },
  //   {
  //     name: "Grand Wedding",
  //     guests: "100-150 guests",
  //     price: "Starting ₹18 Lakhs",
  //     features: [
  //       "3-day celebration",
  //       "Premium décor & lighting",
  //       "Live band & entertainment",
  //       "Full catering (all events)",
  //       "Professional photo/video",
  //       "Guest accommodation included",
  //     ],
  //   },
  //   {
  //     name: "Royal Extravaganza",
  //     guests: "150-200 guests",
  //     price: "Starting ₹35 Lakhs",
  //     features: [
  //       "4-day royal celebration",
  //       "Luxury décor & stage",
  //       "Celebrity performances",
  //       "Gourmet multi-cuisine",
  //       "Cinematic coverage",
  //       "Luxury accommodations",
  //       "Personal concierge",
  //     ],
  //   },
  // ];

  return (
    <>
      {homeLoading && <Preloader />}
      <div className="min-h-screen bg-white text-md">
        {/* Hero Section */}
        <section className="relative min-h-screen flex items-end justify-center overflow-hidden">
          <div
            className="absolute inset-0 z-0"
            style={{
              backgroundImage: `url('${banner?.BannerImage}')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-black/80" />
          </div>

          <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10 mt-25 mb-15">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              {banner?.SubTitle && (
                <div className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-md border border-white/20 px-8 py-4 rounded-full mb-10">
                  <Heart className="h-5 w-5 text-[#C9A962]" />
                  <span className="text-[#C9A962] tracking-[0.4em] text-sm">
                    {banner?.SubTitle || "DESTINATION WEDDINGS"}
                  </span>
                </div>
              )}

              <h1 className="text-white text-3xl md:text-4xl lg:text-5xl mb-10 leading-[1.1] tracking-tight font-playfair">
                {/* Celebrate Love
                <br /> */}
                <span className="text-[#C9A962]">
                  {banner?.BannerTitle ||
                    "Celebrate Love In Places Meant to be Remembered Forever"}
                  {/* In Places Meant to be
                  <br />
                  Remembered Forever */}
                </span>
              </h1>

              {/* <div className="w-32 h-1 bg-[#C9A962] mx-auto mb-12" /> */}

              {banner?.Description && (
                <p
                  className="text-white/95 text-2xl md:text-3xl max-w-4xl mx-auto mb-16 leading-relaxed font-playfair"
                  dangerouslySetInnerHTML={{
                    __html: banner?.Description || "",
                  }}
                />
              )}

              {/* <div className="flex flex-col sm:flex-row gap-6 justify-center">
                <Link href={whatsappLink || "#"} target="_blank">
                  <Button
                    size="lg"
                    className="bg-white hover:bg-white/90 text-[#B42025] px-12 py-7 text-lg"
                  >
                    <MessageCircle className="mr-2 h-6 w-6" />
                    Talk to Wedding Planner
                  </Button>
                </Link>
              </div> */}
            </motion.div>
          </div>
        </section>

        {/* Why Choose Kavish */}
        {lookUpCMSData?.["Weddings - Section 1 : Why Choose Kavish"] && (
          <section className="py-10 md:py-20 bg-white">
            <div
              className="container mx-auto px-4 sm:px-6 lg:px-8"
              dangerouslySetInnerHTML={{
                __html:
                  lookUpCMSData?.["Weddings - Section 1 : Why Choose Kavish"]
                    ?.Template,
              }}
            />
            {/* <div className="container mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-20">
                <p className="text-[#B42025] tracking-[0.3em] mb-4 text-sm uppercase">
                  Why Choose Kavish
                </p>
                <h2 className="text-5xl md:text-7xl mb-8 text-[#1A1A1A]">
                  Your Perfect Wedding Destination
                </h2>
                <p className="text-gray-600 text-2xl max-w-3xl mx-auto">
                  Every wedding at Kavish is unique, personalized, and executed
                  with precision.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-6xl mx-auto">
                <motion.div
                  className="text-center p-12 bg-[#F9F7F4] rounded-3xl hover:shadow-2xl transition-shadow"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.1 }}
                  viewport={{ once: true }}
                >
                  <div className="inline-block p-6 bg-white rounded-full mb-8">
                    <Heart className="h-12 w-12 text-[#B42025]" />
                  </div>
                  <h3 className="text-2xl text-[#1A1A1A] mb-4">
                    Stunning Locations
                  </h3>
                  <p className="text-gray-600 text-lg">
                    From wilderness to lakes to heritage hills
                  </p>
                </motion.div>

                <motion.div
                  className="text-center p-12 bg-[#F9F7F4] rounded-3xl hover:shadow-2xl transition-shadow"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  <div className="inline-block p-6 bg-white rounded-full mb-8">
                    <Users className="h-12 w-12 text-[#B42025]" />
                  </div>
                  <h3 className="text-2xl text-[#1A1A1A] mb-4">
                    Personalized Planning
                  </h3>
                  <p className="text-gray-600 text-lg">
                    Dedicated team for every detail
                  </p>
                </motion.div>

                <motion.div
                  className="text-center p-12 bg-[#F9F7F4] rounded-3xl hover:shadow-2xl transition-shadow"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 }}
                  viewport={{ once: true }}
                >
                  <div className="inline-block p-6 bg-white rounded-full mb-8">
                    <Sparkles className="h-12 w-12 text-[#B42025]" />
                  </div>
                  <h3 className="text-2xl text-[#1A1A1A] mb-4">
                    Luxury Experiences
                  </h3>
                  <p className="text-gray-600 text-lg">
                    Premium accommodations and services
                  </p>
                </motion.div>
              </div>
            </div> */}
          </section>
        )}

        {/* Venue Showcase */}
        {WeddingVenueList && WeddingVenueList?.length > 0 && (
          <section className="py-10 md:py-20 bg-[#F9F7F4]">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
              {lookUpCMSData?.["Weddings - Section 2 : Our Wedding Venues"] ? (
                <div
                  className="text-center mb-20"
                  dangerouslySetInnerHTML={{
                    __html:
                      lookUpCMSData?.[
                        "Weddings - Section 2 : Our Wedding Venues"
                      ]?.Template,
                  }}
                />
              ) : (
                <div className="text-center mb-20">
                  <h2 className="text-2xl md:text-4xl mb-8 text-[#1A1A1A]">
                    Our Wedding Venues
                  </h2>
                  <p className="text-gray-600 text-xl max-w-3xl mx-auto">
                    Each venue offers a distinct character and unforgettable
                    ambiance.
                  </p>
                </div>
              )}

              <div className="space-y-16">
                {WeddingVenueList?.map((venue: any, index: number) => (
                  <motion.div
                    key={index}
                    className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center`}
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.2 }}
                    viewport={{ once: true }}
                  >
                    <div className={`${index % 2 === 1 ? "lg:order-2" : ""}`}>
                      <div className="relative aspect-[16/10] rounded-3xl overflow-hidden shadow-2xl group">
                        <OptimizedImage
                          src={venue?.BannerImage}
                          alt={venue?.Title}
                          className="w-full h-full group-hover:scale-110 transition-transform duration-700"
                          aspectRatio="16/10"
                        />
                        {/* <div className="absolute top-6 left-6 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full">
                        <p className="text-[#B42025] text-sm font-medium">
                          {venue?.Tagline}
                        </p>
                      </div> */}
                      </div>
                    </div>

                    <div className={`${index % 2 === 1 ? "lg:order-1" : ""}`}>
                      {/* <div className="inline-block px-4 py-2 bg-white rounded-full text-xs text-[#B42025] tracking-wider mb-6">
                      VENUE {String(index + 1).padStart(2, "0")}
                    </div> */}

                      <h3 className="text-2xl md:text-4xl mb-6 text-[#1A1A1A]">
                        {venue?.Title}
                      </h3>

                      <p
                        className="text-gray-700 text-xl leading-relaxed mb-6 line-clamp-3"
                        dangerouslySetInnerHTML={{
                          __html: venue?.ShortDescription,
                        }}
                      />

                      {venue?.Capacity && (
                        <div className="flex items-center gap-3 text-[#B42025] mb-10 text-lg">
                          <Users className="h-6 w-6" />
                          <span className="font-medium">
                            Capacity: {venue?.Capacity}
                          </span>
                        </div>
                      )}

                      <Link href={`/weddings-events/${venue?.URL || ""}/`}>
                        <Button className="bg-[#B42025] hover:bg-[#8F1A1E] text-white px-10 py-6 text-lg group">
                          Explore This Venue
                          <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                        </Button>
                      </Link>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* Wedding Packages */}
        {lookUpCMSData?.["Weddings - Section 3 : Wedding Packages"] && (
          <section className="py-10 md:py-20 bg-white">
            <div
              className="container mx-auto px-4 sm:px-6 lg:px-8"
              dangerouslySetInnerHTML={{
                __html:
                  lookUpCMSData?.["Weddings - Section 3 : Wedding Packages"]
                    ?.Template,
              }}
            />
            {/* <div className="container mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-20">
                <h2 className="text-5xl md:text-7xl mb-8 text-[#1A1A1A]">
                  Wedding Packages
                </h2>
                <p className="text-gray-600 text-xl max-w-2xl mx-auto">
                  Flexible options to suit every celebration style and budget
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-7xl mx-auto">
                {packages.map((pkg, index) => (
                  <motion.div
                    key={index}
                    className="bg-[#F9F7F4] rounded-3xl p-10 hover:shadow-2xl transition-all duration-300 relative overflow-hidden group"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="absolute top-0 right-0 w-32 h-32 bg-[#C9A962]/10 rounded-full blur-2xl" />

                    <div className="relative z-10">
                      <div className="inline-block px-4 py-2 bg-white rounded-full text-xs text-[#B42025] tracking-wider mb-6">
                        {pkg.guests}
                      </div>

                      <h3 className="text-3xl text-[#1A1A1A] mb-4">
                        {pkg.name}
                      </h3>
                      <p className="text-4xl text-[#B42025] mb-8">
                        {pkg.price}
                      </p>

                      <div className="space-y-4 mb-10">
                        {pkg.features.map((feature, fIndex) => (
                          <div key={fIndex} className="flex items-start gap-3">
                            <Check className="h-5 w-5 text-[#B42025] mt-1 flex-shrink-0" />
                            <span className="text-gray-700">{feature}</span>
                          </div>
                        ))}
                      </div>

                      <Button className="w-full bg-white hover:bg-[#B42025] text-[#B42025] hover:text-white border-2 border-[#B42025] py-6">
                        Request Details
                      </Button>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div> */}
          </section>
        )}

        {/* Services */}
        {lookUpCMSData?.["Weddings - Section 4 : Wedding Services"] && (
          <section className="py-10 md:py-20 bg-[#F9F7F4]">
            <div
              className="container mx-auto px-4 sm:px-6 lg:px-8"
              dangerouslySetInnerHTML={{
                __html:
                  lookUpCMSData?.["Weddings - Section 4 : Wedding Services"]
                    ?.Template,
              }}
            />
            {/* <div className="container mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-20">
                <h2 className="text-5xl md:text-7xl mb-8 text-[#1A1A1A]">
                  Complete Wedding Services
                </h2>
                <p className="text-gray-600 text-xl max-w-2xl mx-auto">
                  From planning to execution, we handle everything.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                {services.map((service, index) => (
                  <motion.div
                    key={index}
                    className="bg-white rounded-3xl p-10 hover:shadow-2xl transition-all duration-300"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1 }}
                    viewport={{ once: true }}
                  >
                    <div className="inline-block p-5 bg-[#F9F7F4] rounded-full mb-8">
                      <service.icon className="h-10 w-10 text-[#B42025]" />
                    </div>
                    <h3 className="text-2xl text-[#1A1A1A] mb-4">
                      {service.title}
                    </h3>
                    <p className="text-gray-700 text-lg leading-relaxed">
                      {service.description}
                    </p>
                  </motion.div>
                ))}
              </div>
            </div> */}
          </section>
        )}

        {/* CTA */}
        <section className="py-10 md:py-20 bg-[#1A1A1A] relative overflow-hidden">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
            {lookUpCMSData?.["Weddings - Section 5 : CTA"] ? (
              <div
                className="container mx-auto px-4 sm:px-6 lg:px-8"
                dangerouslySetInnerHTML={{
                  __html:
                    lookUpCMSData?.["Weddings - Section 5 : CTA"]?.Template,
                }}
              />
            ) : (
              <>
                <Heart className="h-20 w-20 text-[#C9A962] mx-auto mb-10" />
                <h2 className="text-white text-2xl md:text-4xl mb-10">
                  Let's Plan Your Dream Wedding
                </h2>
                <p className="text-white/90 text-lg md:text-2xl max-w-3xl mx-auto mb-16">
                  Share your vision with us, and we'll create a celebration as
                  unique as your love story.
                </p>
              </>
            )}
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              {/* <Button
                size="lg"
                className="bg-[#B42025] hover:bg-[#8F1A1E] text-white px-12 py-7 text-lg"
              >
                <Gift className="mr-2 h-6 w-6" />
                Request Wedding Brochure
              </Button> */}
              <Link href={whatsappLink || "#"} target="_blank">
                <Button
                  size="lg"
                  className="bg-white text-[#B42025] hover:bg-white/90 px-12 py-7 text-lg"
                >
                  <MessageCircle className="mr-2 h-6 w-6" />
                  WhatsApp Wedding Team
                </Button>
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
